import React from 'react';

function Home() {
  return (
    <div>
      <h1>Welcome to Our E-commerce Store</h1>
      <p>Check out our amazing products!</p>
    </div>
  );
}

export default Home;